import React from "react";
import styled from "@emotion/styled";

import { Portfolio } from "@/services/UserService";
import { useFileSignedUrl } from "@/services/ContractsService";

const StyledTitle = styled.div`
  font-size: 1.75rem;
  font-weight: 300;
`;

const StyledImageContainer = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
  height: 26rem;
  width: 100%;
  border-radius: 2rem;
  padding: 1.25rem;

  img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: inherit;
    background-color: rgba(0, 0, 0, 0.1);
    object-fit: cover;
    z-index: 0;
  }
`;

const StyledTagsContainer = styled.div`
  position: relative;
  display: flex;
  gap: 1rem;
  border-radius: 1rem;
  z-index: 1;
`;

const StyledTag = styled.div`
  padding: 0.5rem 1rem;
  background: #fff;
  color: #000;
  font-size: 0.9rem;
  border-radius: 10rem;
  border: 1px solid rgba(0, 0, 0, 0.125);
`;

const PorfolioCard: React.FC<{ portfolio: Portfolio; className?: string }> = ({
  portfolio,
  className,
}) => {
  const { name, attachments = [], tech = [] } = portfolio;
  const firstImage = attachments.length ? attachments[0] : null;
  const { url } = useFileSignedUrl(firstImage?.url || "");

  return (
    <div className={className}>
      <StyledImageContainer>
        <img src={url} alt="" />
        {!!tech.length && (
          <StyledTagsContainer>
            {tech.map((tag, i) => (
              <StyledTag key={i}>{tag}</StyledTag>
            ))}
          </StyledTagsContainer>
        )}
      </StyledImageContainer>
      <StyledTitle className="mt-4">{name}</StyledTitle>
    </div>
  );
};

export default PorfolioCard;
